/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Entity } from '../../models/entity';

export interface ApiTapioSearchUserGet$Plain$Params {
  ENTITY_ID?: string;
  USERNAME?: string;
  GET_CARDS?: boolean;
  Authorization?: string;
}

export function apiTapioSearchUserGet$Plain(http: HttpClient, rootUrl: string, params?: ApiTapioSearchUserGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Entity>>> {
  const rb = new RequestBuilder(rootUrl, apiTapioSearchUserGet$Plain.PATH, 'get');
  if (params) {
    rb.query('ENTITY_ID', params.ENTITY_ID, {});
    rb.query('USERNAME', params.USERNAME, {});
    rb.query('GET_CARDS', params.GET_CARDS, {});
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Entity>>;
    })
  );
}

apiTapioSearchUserGet$Plain.PATH = '/api/Tapio/SearchUser';
